import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkMode } from '../../context/WorkModeContext';
import ActiveOrdersWidget from '../dock-widgets/ActiveOrdersWidget';
import QuickCashWidget from '../dock-widgets/QuickCashWidget';
import TablesWidget from '../dock-widgets/TablesWidget';
import AlertsWidget from '../dock-widgets/AlertsWidget';
import './DockPanel.css';

const DockPanel = ({ isExpanded, onToggle }) => {
  const { t } = useTranslation();
  const { workMode, visibleWidgets } = useWorkMode();
  const [collapsedWidgets, setCollapsedWidgets] = useState({});

  const allWidgets = [
    {
      id: 'orders',
      icon: 'receipt_long',
      label: t('dock.activeOrders', 'Pedidos'),
      component: ActiveOrdersWidget,
    },
    {
      id: 'cash',
      icon: 'point_of_sale',
      label: t('dock.quickCash', 'Caja'),
      component: QuickCashWidget,
    },
    {
      id: 'tables',
      icon: 'table_restaurant',
      label: t('dock.tables', 'Mesas'),
      component: TablesWidget,
    },
    {
      id: 'alerts',
      icon: 'notifications',
      label: t('dock.alerts', 'Alertas'),
      component: AlertsWidget,
    },
  ];

  const activeWidgets = allWidgets.filter((w) => visibleWidgets.includes(w.id));

  const toggleWidgetCollapse = (widgetId) => {
    setCollapsedWidgets((prev) => ({
      ...prev,
      [widgetId]: !prev[widgetId],
    }));
  };

  if (workMode === 'admin') {
    return null;
  }

  return (
    <div className={`dock-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      {/* Collapsed state - icon bar */}
      {!isExpanded && (
        <div className="dock-collapsed-bar">
          <button
            type="button"
            className="dock-expand-btn"
            onClick={() => onToggle(true)}
            title={t('dock.expand', 'Expandir')}
            aria-label={t('dock.expand', 'Expandir')}
          >
            <span className="material-icons">chevron_left</span>
          </button>
          {activeWidgets.map((widget) => (
            <button
              type="button"
              key={widget.id}
              className="dock-collapsed-icon"
              onClick={() => onToggle(true)}
              title={widget.label}
              aria-label={widget.label}
            >
              <span className="material-icons">{widget.icon}</span>
            </button>
          ))}
        </div>
      )}

      {/* Expanded state - full panel */}
      {isExpanded && (
        <div className="dock-expanded">
          <div className="dock-header">
            <span className="dock-title">
              <span className="material-icons">widgets</span>
              {t('dock.tools', 'Herramientas')}
            </span>
            <button
              type="button"
              className="dock-collapse-btn"
              onClick={() => onToggle(false)}
              title={t('dock.collapse', 'Colapsar')}
              aria-label={t('dock.collapse', 'Colapsar')}
            >
              <span className="material-icons">chevron_right</span>
            </button>
          </div>

          <div className="dock-widgets">
            {activeWidgets.map((widget) => {
              const WidgetComponent = widget.component;
              const isCollapsed = collapsedWidgets[widget.id];

              return (
                <div key={widget.id} className={`dock-widget ${isCollapsed ? 'collapsed' : ''}`}>
                  <div
                    className="dock-widget-header"
                    onClick={() => toggleWidgetCollapse(widget.id)}
                  >
                    <span className="material-icons widget-icon">{widget.icon}</span>
                    <span className="widget-title">{widget.label}</span>
                    <span className="material-icons collapse-icon">
                      {isCollapsed ? 'expand_more' : 'expand_less'}
                    </span>
                  </div>
                  {!isCollapsed && (
                    <div className="dock-widget-content">
                      <WidgetComponent />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default DockPanel;
